/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';

import { TreeItemProps } from '@mui/x-tree-view';

import { createProjectTreeItemStyles, StyledProjectTreeItem } from './ProjectTreeItem.styles';

type ProjectTreeItemProps = TreeItemProps & {
  labelText: string;
  labelIcon?: React.ReactElement<any>;
};

export const ProjectTreeItem = memo<ProjectTreeItemProps>(props => {
  const { labelText, labelIcon, ...otherProps } = props;
  const classes = createProjectTreeItemStyles();
  return (
    <StyledProjectTreeItem
      label={
        <div>
          <div className={classes.iconRoot}>{labelIcon}</div>
          <div>{labelText}</div>
        </div>
      }
      {...otherProps}
    />
  );
});

ProjectTreeItem.displayName = 'ProjectTreeItem';
